import { groupBy } from 'lodash'

// vendibles一覧(APIの data.vendibles.data、またはCourseに絞った配列)から
// コース選択用の選択肢 [{ id, name }] を作る。
// idはサーバー値(整数)と型を揃えるため数値化する（v-selectのitem-value一致用）。
export const toCourseOptions = vendibles => (
  (groupBy(vendibles || [], 'attributes.vendibleType').Course || [])
    .map(course => ({ id: Number(course.id), name: course.attributes.name }))
)

export default toCourseOptions
